import { useEffect, useState } from "react";
import BreadCrumb from "../../../../components/breadcrumb";
import Header from "../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../components/DashboardNavigation/sidebar";
import { BudgetData } from "../../../../components/tables/budget-tables/budget";
import { getAllBudget } from "../../../../API/Budget/budgetService";

const breadcrumbItems = [
  { title: "Budgets", link: "/admin-dashboard/budgets" },
];
export default function Budget() {
  const [budgets, setBudgets] = useState<any[]>([]);
  const fetchData = async () => {
    const response = await getAllBudget();
    setBudgets(response?.budgets);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <BudgetData data={budgets} />
        </div>
      </div>
    </>
  );
}
